import { render, staticRenderFns } from "./GExamCreateExamineeSetting.vue?vue&type=template&id=18e813a2&scoped=true&"
import script from "./GExamCreateExamineeSetting.vue?vue&type=script&lang=ts&"
export * from "./GExamCreateExamineeSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e813a2",
  null
  
)

export default component.exports